/*
 *
 * LeftMenu
 *
 */

import React from 'react';
import {
  Wrapper,
  NavContainer,
  Content,
  HomeIcon,
  SignOutButton,
  MenuList,
  A
} from './styledComponents';
import Button from './Button';
import Logo from 'components/Logo';
import Icon from 'components/Icon';

// `items` replaces the standard links for a dashboard with fewer surfaces
// (the free event's limited dashboard and restore screen): [{ resource | href,
// name, iconName }].
const LeftMenu = ({ children, avatarUrl, signOut, showAdminLink, items }) => (
  <Wrapper>
    <NavContainer>
      <MenuList>
        <HomeIcon>
          <Logo name='home' />
        </HomeIcon>
        {items ? items.map((item) => (
          <Button
            key={item.name}
            {...item}
            {...(item.href ? { target: "_blank", rel: "noreferrer noopener" } : {})}
          />
        )) : (<>
        <Button resource='channels' name='Channels' iconName='channels' />
        <Button resource='leads' name='Leads' iconName='leads' />
        {/* Superadmin-only link, gated upstream in App by role + the
            react_superadmin_enabled flag. Routes to the gated /admin section. */}
        {showAdminLink && (
          <Button resource='admin' name='Admin' iconName='account' />
        )}
        <Button href='https://help.mvbth.com' target="_blank" rel="noreferrer noopener" iconName='help' name="Help" />
        <Button resource='account' name='Settings' iconName='account' />
        </>)}
      </MenuList>
      <SignOutButton onClick={() => signOut()}>
        Sign out
      </SignOutButton>
    </NavContainer>
    <Content>
      {children}
      <Icon className="footer-logo" viewBox="0 0 123 10" width='123' height="10" name='faded_logo' />
    </Content>
  </Wrapper>
);

export default LeftMenu;
